import {
  I_CallToAction,
  I_CallToActionConfigGlobal,
} from '@containers/Home/types';
import dynamic from 'next/dynamic';
import { memo, useState } from 'react';

const Item = dynamic(() => import('./Item'));

interface Props {
  listCallToAction?: I_CallToAction[];
  callToActionConfig?: I_CallToActionConfigGlobal;
}

const CallToAction = memo(
  ({ listCallToAction = [], callToActionConfig }: Props) => {
    const [isShowPanel, setIsShowPanel] = useState(false);
    const isBubbleLayout = callToActionConfig?.layout === 'bubble';
    const isLeftPosition = callToActionConfig?.position === 'left';
    const layoutVariant = isBubbleLayout ? 'panel' : 'list';
    const positionVariant = isLeftPosition ? 'left' : 'right';
    const offsetLeft = callToActionConfig?.offsetLeft || 0;
    const offsetRight = callToActionConfig?.offsetRight || 0;
    const offsetBottom = callToActionConfig?.offsetBottom || 0;

    return (
      <div
        id="themeCTA"
        className="absolute z-20"
        style={{
          bottom: isBubbleLayout ? `${offsetBottom}px` : '165px',
          left: isLeftPosition ? `${offsetLeft}px` : undefined,
          right: isLeftPosition ? undefined : `${offsetRight}px`,
        }}
      >
        <div
          className={`size-14 cursor-pointer items-center justify-center rounded-full bg-[var(--color-primary)] text-[1.25rem] text-[var(--color-text)] backdrop-blur-sm ${
            isBubbleLayout ? 'flex' : 'hidden'
          }`}
          onClick={() => setIsShowPanel(prev => !prev)}
        >
          <i
            aria-hidden
            className={`fal fa-${isShowPanel ? 'times' : 'ellipsis-v'}`}
          />
        </div>
        <div
          className={`absolute flex w-max flex-col ${
            isBubbleLayout
              ? `p-2 bottom-16 min-w-40 rounded-2xl backdrop-blur-sm bg-[var(--color-primary)] text-[var(--color-text)] [transition:all_0.35s_cubic-bezier(0.45,1.83,0.6,0.97)] ${
                  isShowPanel
                    ? 'pointer-events-auto scale-100 opacity-100'
                    : 'pointer-events-none scale-50 opacity-0'
                } ${
                  isLeftPosition
                    ? 'left-0 origin-bottom-left'
                    : 'right-0 origin-bottom-right'
                }`
              : `bottom-4 my-auto h-max items-center justify-center gap-2`
          }`}
          style={
            isBubbleLayout
              ? undefined
              : isLeftPosition
              ? { left: `${offsetLeft}px` }
              : { right: `${offsetRight}px` }
          }
        >
          {listCallToAction.map((item, index) => (
            <Item
              key={item.id}
              item={item}
              layoutVariant={layoutVariant}
              position={positionVariant}
              isPanelOpen={isShowPanel}
              itemIndex={index}
            />
          ))}
        </div>
      </div>
    );
  },
);

export default CallToAction;
